import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Modal, // Keep Modal
  Box,   // Keep Box
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Table,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import Autocomplete from "@mui/material/Autocomplete";
import { Margin } from "@mui/icons-material";
import nopdf from '../../../assets/images/nopdf.png'
import moment from 'moment';
import { getSecureDevId } from "../../../utils/storageHelpers";

// Define the style for the modal content box
const modalStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: '90%', sm: '60%', md: '400px' }, // Responsive width
  bgcolor: "background.paper", // Use theme background
  border: '1px solid #ccc',
  borderRadius: '8px', // Add rounded corners
  boxShadow: 24,
  p: 4, // Padding
  textAlign: 'center', // Center text/button inside
};

type Props = {};

const SplitPDF = (props: Props) => {

  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [selectedRow, setSelectedRow] = useState<any>([]);

  let navigate = useNavigate();
  const { i18n, t } = useTranslation();

  const [toaster, setToaster] = useState(false);
  const [tableData, setTableData] = useState<any>([]);
  const [DocFileOption, setDocFileOption] = useState([{ value: "-1", label: t("text.SelectFileType") }]);
  const [StatusOption, setStatusOption] = useState([{ value: "-1", label: t("text.SelectFileStatus") }]);
  const [DocOption, setDocOption] = useState([{ value: "-1", label: t("text.SelectFileNo") }]);

  // State to control modal visibility and background blur
  const [active, setActive] = useState(false);

  const devId = getSecureDevId();

  function formatDate(dateString: any) {
    if (!dateString) return ""; // Return empty string if date is not provided
    return moment(dateString).format('DD-MM-YYYY');
  }

  useEffect(() => {
    const dataString = localStorage.getItem("userdata");
    getFileType();
    getFileStatus();
    getDoc();
  }, []);

  const getDocMng = () => {
    setActive(false); // Ensure modal is closed before new search
    const collectData = {
      fromDate: formik.values.fDate.toString() || "",
      toDate: formik.values.perUt.toString() || "",
      filestatus: "",
      textSearch: formik.values.textSearch.toString() || "",
      docMid: formik.values.docMid.toString() || "",
      fileTypId: "",
      //@ts-ignore
      divisionid: "",
      user_Id: -1,
    };
    axios
      .post(HOST_URL.HOST_URL2 + `DocMangr/GetDocMangrForIndex`, collectData)
      .then((res) => {
        const arr: any = [];
        console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            id: res.data.data[index]["pdFid"],
            fileNo: res.data.data[index]["fileNo"],
            docMid: res.data.data[index]["docMid"],
            fileDef: res.data.data[index]["fileDef"],
            synopsis: res.data.data[index]["synopsis"],
            fileType: res.data.data[index]["fileType"],
            subject: res.data.data[index]["subject"],
            fDate: res.data.data[index]["fDate"],
            perUt: res.data.data[index]["perUt"],
            ismain: res.data.data[index]["ismain"],
            pdfName: res.data.data[index]["pdfName"],
            docFile: res.data.data[index]["docFile"],
            pdFid: res.data.data[index]["pdFid"],
            complt: res.data.data[index]["complt"],
            partNo: res.data.data[index]["partNo"],
            comments: res.data.data[index]["comments"],
            pgNF: res.data.data[index]["pgNF"],
            pgNu: res.data.data[index]["pgNu"],
            phySNo: res.data.data[index]["phySNo"],
            phyIndex: res.data.data[index]["phyIndex"],
            relOfficer: res.data.data[index]["relOfficer"],
            subSubject: res.data.data[index]["subSubject"],
            insname: res.data.data[index]["insname"],
            userid: res.data.data[index]["userid"],
            keywords: res.data.data[index]["keywords"],
            doc_name: res.data.data[index]["doc_name"],
            perFr: res.data.data[index]["perFr"],
            cDate: res.data.data[index]["cDate"],
            entryDate: res.data.data[index]["entryDate"],
            filename: res.data.data[index]["filename"],
            pagecount: res.data.data[index]["pagecount"],
            divisionid: res.data.data[index]["divisionid"],
            isSelected: false,
          });
        }
        setTableData(arr);
      })
      .catch(error => {
        console.error("Error fetching documents:", error);
        toast.error("Failed to fetch documents.");
        setActive(false); // Ensure modal is closed on error too
      });
  };

  const AddSplitPdf = () => {
    var array1: any[] = []; // Explicitly type array1
    let hasSelection = false; // Flag to check if any row is selected

    for (let index = 0; index < tableData.length; index++) {
      const rowData = tableData[index];
      var array2: any[] = []; // Explicitly type array2

      if (rowData.isSelected === true) { // Strict comparison
        hasSelection = true; // Mark that at least one row is selected
        array2.push({ "chkSplit": true, "pdfName": rowData.pdfName, "pdFid": rowData.pdFid });
        array1.push({ "docMid": rowData.docMid, "divisionid": rowData.divisionid, docMangrSplits: array2 });
      }
    }

    // Prevent API call if nothing is selected
    if (!hasSelection) {
      toast.warning("Please select at least one PDF file to split.");
      return; // Exit the function
    }

    const collectData = {
      docMangrReqForSplit: array1
    };



    axios.post(HOST_URL.HOST_URL2 + `SplitPdf/AddUpdateSplitPdf`, collectData)
      .then(response => {
        if (response.data.status === 1) { // Strict comparison
          console.log("Split PDF API response:", response);
          toast.success("Split request submitted successfully! You can now proceed to indexing.");
          setActive(true); // Show the modal with the button

        } else {
          // Provide more specific error if possible from response
          const errorMessage = response.data.message || "Error processing split request.";
          toast.error(errorMessage);
          setActive(false); // Keep modal closed on error
        }
      })
      .catch(error => {
        console.error("Error in Split PDF API:", error);
        toast.error("An error occurred while submitting the split request.");
        setActive(false); // Keep modal closed on error
      });
  }

  const getFileType = () => {
    const collectData = { docID: -1, parentDocId: -1, userId: "", };
    axios
      .post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, collectData)
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({
          label: item.doc_Name,
          value: item.docID
        }));
        setDocFileOption([{ value: "-1", label: t("text.SelectFileType") }, ...arr]); // Add default option back
      }).catch(err => console.error("Failed to get file types", err));
  };

  const getDoc = () => {
    const collectData = {
      docMid: -1, fileTypId: -1,
      //@ts-ignore
      divisionid: devId === null || devId === "null" ? "" : Number(devId),
      subsubjId: -1, user_Id: -1, fileNo: ""
    };
    axios
      .post(HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`, collectData)
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({
          label: item.fileNo ? `${item.fileNo} (${item.synopsis})` : "_ _",
          value: item.docMid
        }));
        setDocOption([{ value: "-1", label: t("text.SelectFileNo") }, ...arr]); // Add default option back
      }).catch(err => console.error("Failed to get docs", err));
  };

  const getFileStatus = () => {
    const collectData = {};
    axios
      .post(HOST_URL.HOST_URL2 + `FileStatus/GetFileStatus`, collectData)
      .then((res) => {
        var array = [];
        for (let index = 0; index < res.data.data.length; index++) {
          array.push({
            label: res.data.data[index]["fStatus"],
            value: res.data.data[index]["fStatus"],
          });
        }
        setStatusOption([{ value: "-1", label: t("text.SelectFileStatus") }, ...array]); // Add default option back
      }).catch(err => console.error("Failed to get file status", err));
  };

  const handleInputChange = (id: number, columnName: string, checked: boolean) => {
    setTableData((prevTableData: any) =>
      prevTableData.map((row: any) =>
        row.id === id ? { ...row, [columnName]: checked } : row
      )
    );
  };

  const formik = useFormik({
    initialValues: {
      docMid: "", fDate: "", perUt: "", textSearch: "",
      // Keep other initial values if needed, but these are the main search ones
      // ... other fields ...
      fileNo: "", fileDef: "", synopsis: "", complt: "", fileType: "", subj: "",
      partNo: "", pFileNo: "", userId: "", perFr: "", authPersn: "",
      subsubjId: 0, sub_Subject_Name: "", divisionid: 0, division_name: "",
      filestatus: "", fileTypId: "", createdate: "", user_Id: 1,
    },
    onSubmit: async (values) => {
      // The main action is triggered by the search button (getDocMng)
      // This onSubmit might not be strictly needed unless you have other form actions
      console.log("Form submitted (though search is manual)", values);
    },
  });

  // Removed handleCheckboxChange as handleInputChange covers the checkbox state now.

  const back = useNavigate();

  return (
    // Use React Fragment to allow modal as a sibling to the main content div
    <>
      {/* Wrap main content for blurring */}
      <div
        style={{
          padding: "-5px 5px",
          filter: active ? "blur(4px)" : "none", // Apply blur when active
          transition: "filter 0.3s ease-out", // Smooth transition for blur
          pointerEvents: active ? "none" : "auto", // Prevent interaction with blurred background
          // The rest of your existing styles for this div
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #42AEEE",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.SplitPdfToJump")}
          </Typography>

          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="button" // Change to button if not submitting form
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20, // Consider using padding/minWidth for better icon button sizing
                }}
                aria-label="Go back" // Add aria-label for accessibility
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          {/* Use form tag if needed, but button clicks trigger actions directly */}
          {/* <form onSubmit={formik.handleSubmit}> */}
          <ToastApp />
          <Grid item xs={12} container spacing={2}>
            {/* --- Search Fields --- */}
            <Grid item lg={3} xs={12}>
              <Autocomplete
                disablePortal
                id="doc-select" // Unique ID
                options={DocOption}
                getOptionLabel={(option) => option.label || ""} // Handle potential null labels
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                value={
                  DocOption.find((opt) => opt.value === formik.values.docMid) ||
                  null
                }
                fullWidth
                size="small"
                onChange={(event, newValue) => {
                  formik.setFieldValue("docMid", newValue?.value || ""); // Handle null case
                }}
                renderInput={(params) => (
                  <TextField {...params} label={t("text.SelectFileNo")} />
                )}
              />
              {/* Removed redundant touched/error logic if not using Yup validation here */}
            </Grid>

            <Grid item md={3} xs={12}>
              <TextField
                type="text"
                InputLabelProps={{ shrink: true }}
                id="textSearch"
                name="textSearch"
                label={t("text.TextSearch")}
                value={formik.values.textSearch}
                placeholder={t("text.TextSearch")}
                size="small"
                fullWidth
                style={{ backgroundColor: "white" }}
                onChange={formik.handleChange}
              // No need for onBlur if not validating on blur
              />
            </Grid>

            <Grid item md={2} xs={12}>
              <TextField
                type="date"
                InputLabelProps={{ shrink: true }}
                id="fDate"
                name="fDate"
                label={t("text.FromDate")}
                value={formik.values.fDate}
                size="small"
                fullWidth
                style={{ backgroundColor: "white" }}
                onChange={formik.handleChange}
              />
            </Grid>

            <Grid item md={2} xs={12}>
              <TextField
                type="date"
                InputLabelProps={{ shrink: true }}
                id="perUt"
                name="perUt"
                label={t("text.PeriodUpto")}
                value={formik.values.perUt}
                size="small"
                fullWidth
                style={{ backgroundColor: "white" }}
                onChange={formik.handleChange}
              />
            </Grid>

            <Grid item md={2} xs={12}>
              {" "}
              {/* Adjusted grid size */}
              <Button
                onClick={getDocMng}
                fullWidth
                variant="contained" // Make it contained for primary action feel
                style={{
                  backgroundColor: `var(--header-background)`,
                  color: "white",
                  height: "40px", // Match typical TextField small height
                }}
              >
                {t("text.search")}
              </Button>
            </Grid>

            {/* --- Results Table --- */}
            <Grid item xs={12} mt={2}>
              {" "}
              {/* Added margin top for spacing */}
              {tableData.length > 0 ? ( // Conditionally render table only if data exists
                <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                  {" "}
                  {/* Make table scrollable */}
                  <Table
                    stickyHeader // Keep header visible when scrolling
                    style={{
                      borderCollapse: "collapse",
                      width: "100%",
                      border: "1px solid #ddd", // Lighter border
                    }}
                  >
                    <thead
                      style={{
                        backgroundColor: `var(--header-background)`,
                        color: `var(--header-color)`,
                      }}
                    >
                      <tr>
                        <th
                          style={{
                            border: "1px solid #ddd",
                            padding: "8px",
                            textAlign: "center",
                          }}
                        >
                          {t("text.Action")}
                        </th>
                        <th
                          style={{
                            border: "1px solid #ddd",
                            padding: "8px",
                            textAlign: "left",
                          }}
                        >
                          {t("text.FileNo")}
                        </th>
                        <th
                          style={{
                            border: "1px solid #ddd",
                            padding: "8px",
                            textAlign: "left",
                          }}
                        >
                          {t("text.PdfFileName")}
                        </th>
                        <th
                          style={{
                            border: "1px solid #ddd",
                            padding: "8px",
                            textAlign: "left",
                          }}
                        >
                          {t("text.FileName")}
                        </th>
                        <th
                          style={{
                            border: "1px solid #ddd",
                            padding: "8px",
                            textAlign: "left",
                          }}
                        >
                          {t("text.FileType")}
                        </th>
                        <th
                          style={{
                            border: "1px solid #ddd",
                            padding: "8px",
                            textAlign: "left",
                          }}
                        >
                          {t("text.Subject")}
                        </th>
                        <th
                          style={{
                            border: "1px solid #ddd",
                            padding: "8px",
                            textAlign: "center",
                          }}
                        >
                          {t("text.DateFrom")}
                        </th>
                        <th
                          style={{
                            border: "1px solid #ddd",
                            padding: "8px",
                            textAlign: "center",
                          }}
                        >
                          {t("text.DateTo")}
                        </th>
                      </tr>
                    </thead>
                    <tbody style={{ border: "1px solid #ddd" }}>
                      {tableData.map(
                        (
                          row: any // Removed index if not used
                        ) => (
                          <tr
                            key={row.id}
                            style={{
                              borderBottom: "1px solid #ddd",
                              backgroundColor: row.isSelected
                                ? "#eef"
                                : "white",
                            }}
                          >
                            <td
                              style={{
                                border: "1px solid #ddd",
                                padding: "8px",
                                textAlign: "center",
                              }}
                            >
                              <input
                                type="checkbox"
                                style={{ cursor: "pointer" }} // Indicate interactivity
                                checked={row.isSelected || false} // Ensure controlled component
                                onChange={(e) =>
                                  handleInputChange(
                                    row.id,
                                    "isSelected",
                                    e.target.checked
                                  )
                                }
                                aria-label={`Select file ${row.fileNo}`} // Accessibility
                              />
                            </td>
                            <td
                              style={{
                                border: "1px solid #ddd",
                                padding: "8px",
                                textAlign: "left",
                              }}
                            >
                              {row.fileNo}
                            </td>
                            <td
                              style={{
                                border: "1px solid #ddd",
                                padding: "8px",
                                textAlign: "left",
                              }}
                            >
                              {row.fileDef}
                            </td>
                            <td
                              style={{
                                border: "1px solid #ddd",
                                padding: "8px",
                                textAlign: "left",
                              }}
                            >
                              {row.synopsis}
                            </td>
                            <td
                              style={{
                                border: "1px solid #ddd",
                                padding: "8px",
                                textAlign: "left",
                              }}
                            >
                              {row.fileType}
                            </td>
                            <td
                              style={{
                                border: "1px solid #ddd",
                                padding: "8px",
                                textAlign: "left",
                              }}
                            >
                              {row.subject}
                            </td>
                            <td
                              style={{
                                border: "1px solid #ddd",
                                padding: "8px",
                                textAlign: "center",
                              }}
                            >
                              {formatDate(row.fDate)}
                            </td>
                            <td
                              style={{
                                border: "1px solid #ddd",
                                padding: "8px",
                                textAlign: "center",
                              }}
                            >
                              {formatDate(row.perUt)}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <Typography
                  sx={{ textAlign: "center", mt: 3, fontStyle: "italic" }}
                >
                  {t("text.NoDataFound")}
                </Typography>
              )}
            </Grid>
          </Grid>

          {/* --- Split Button (Only shown if data exists) --- */}
          {tableData.length > 0 && (
            <Grid
              item
              xs={12}
              mt={2} // Add margin top
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Grid item xs={12} sm={6} md={4}>
                {" "}
                {/* Responsive width */}
                <Button
                  type="button"
                  onClick={AddSplitPdf}
                  fullWidth
                  variant="contained"
                  style={{
                    backgroundColor: !tableData.some(
                      (row: any) => row.isSelected
                    )
                      ? "#cccccc" // Disabled background
                      : "var(--header-background)",
                    color: !tableData.some((row: any) => row.isSelected)
                      ? "#666666" // Disabled text color
                      : "var(--header-color)",
                    cursor: !tableData.some((row: any) => row.isSelected)
                      ? "not-allowed"
                      : "pointer",
                  }}
                  disabled={!tableData.some((row: any) => row.isSelected)}
                >
                  {t("text.SplitPage")}
                </Button>
              </Grid>
            </Grid>
          )}
          {/* Removed the conditional rendering of the "Go to document indexing" button from here */}
          {/* </form> */}
        </CardContent>
      </div>

      {/* --- Modal for "Go to Document Indexing" --- */}
      <Modal
        open={active}
        onClose={() => setActive(false)} // Optional: Allow closing modal by clicking backdrop
        aria-labelledby="split-success-modal-title"
        aria-describedby="split-success-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography
            id="split-success-modal-title"
            variant="h6"
            component="h2"
          >
            Split Request Submitted
          </Typography>

          <Button
            variant="contained"
            onClick={() => navigate("/DocManagement/DocumentIndexing")}
            style={{
              backgroundColor: `var(--header-background)`,
              color: `var(--header-color)`,
            }}
          >
            Go to Next Step
          </Button>
          <Button
            variant="outlined"
            onClick={() => setActive(false)} // Add a close button
            style={{ marginLeft: "10px" }}
          >
            Close
          </Button>
        </Box>
      </Modal>
    </> // End of React Fragment
  );
};

export default SplitPDF;